{{#if params}}
  <hr/>
  {{#each params}}
    <div class="snippet-field">
      <label>{{ this.title }}</label>
      {{#if this.options}}
        {{sp_select_tag @key choices=this.select_items selected=this.value searchable=this.select_searchable required=true includeBlank=false}}
      {{else}}
        {{#equal this.title 'Formula'}}
          <input type="hidden" name="tribute_resource_type" id="tribute_resource_type" value="{{{ currentResourceType }}}">
          <textarea id="snippet-{{@key}}" name="{{@key}}" placeholder="{{this.placeholder}}">{{this.value}}</textarea>
          <div class="field-comment">You can <a data-remote="true" href="/admin/export_fields/formula_playground?formula_field=snippet-{{@key}}&resource_type={{{ currentResourceType }}}">Test your Formula</a> against real data. For more information on Syntax please see <a data-key="reports-formulas" class="help-link" href="javascript:void(0)">Formulas</a></div>
        {{else}}
        <input name="{{@key}}" value="{{this.value}}" placeholder="{{this.placeholder}}" />
        {{/equal}}
      {{/if}}
    </div>
  {{/each}}
{{/if}}
